/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Skeleton } from 'antd';
import { CSSProperties, FC } from 'react';
import { searchPageSizeAtom } from 'packages/omnitag/state';
import { ResultsPagination } from 'packages/omnitag/results/results-pagination';
import {
  ResultsGrid,
  stylesGrid,
} from 'packages/polaris/tool/results/results-grid';
import { thumbnailContainerClass } from 'packages/polaris/tool/results/result-item';
import { useAtomValue } from 'jotai';
import styled from '@emotion/styled';
import { useRecoilValue } from 'recoil';
import { uiThemeAtom } from 'packages/at-shell/state/recoil/ui';
import { useTourRef } from 'packages/omnitag/hooks/use-tour-refs';

const styles: { [name: string]: CSSProperties } = {
  gridScroll: {
    padding: `1rem 0 0 1rem`,
    marginTop: '1em',
    overflowY: 'auto',
    display: 'flex',
    height: 'calc(100vh - 246px)',
  },
};

const GridContainer = styled.div<{
  isDark: boolean;
}>`
  background: ${({ isDark }): string => (isDark ? '#000000' : '#ffffff')};
  border: 1px solid ${({ isDark }): string => (isDark ? '#222222' : '#eeeeee')};
  height: 100%;
  width: 100%;
  position: relative;
`;

const PaginationPanel = styled.div<{
  isDark: boolean;
}>`
  background: ${({ isDark }): string => (isDark ? '#000000' : '#ffffff')};
  border: 1px solid ${({ isDark }): string => (isDark ? '#222222' : '#eeeeee')};
  padding: 0.8rem;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 56;
`;

export const LoadingResults = (): JSX.Element => {
  const pageSize = useAtomValue(searchPageSizeAtom);
  const cells = [];
  for (let i = 0; i < pageSize; i++) {
    cells.push(<LoadingThumbnail key={i} />);
  }
  return <div style={stylesGrid.grid}>{cells}</div>;
};

export const LoadingThumbnail: FC = () => {
  return (
    <div className={thumbnailContainerClass}>
      <Skeleton.Image active />
    </div>
  );
};

export const ResultsLayout = (): JSX.Element => {
  const theme = useRecoilValue(uiThemeAtom);
  const resultsRef = useTourRef<HTMLDivElement>('results-grid');

  return (
    <>
      <GridContainer isDark={theme === 'dark'}>
        <div style={styles.gridScroll} ref={resultsRef}>
          <ResultsGrid />
        </div>
      </GridContainer>
      <PaginationPanel isDark={theme === 'dark'}>
        <ResultsPagination />
      </PaginationPanel>
    </>
  );
};
